import { useQueryClient } from 'react-query';
import { useNoOrderDeliveryItems } from '../../utils/api.hook';
import { ScheduleNoOrderItemsComponent } from './schedule-no-order-items.component';

export function ScheduleNoOrderItemsContainer() {
  const queryClient = useQueryClient();
  const {
    data: { items = [] } = {},
    isLoading,
    dataUpdatedAt,
  } = useNoOrderDeliveryItems();

  const handleRefresh = () => {
    queryClient.invalidateQueries('noOrderDeliveryItems');
  };

  return (
    <ScheduleNoOrderItemsComponent
      items={items}
      isLoading={isLoading}
      updatedAt={dataUpdatedAt || null}
      onRefresh={handleRefresh}
    />
  );
}
